<script>
import api from '@/helpers/api'
import { required, minValue, decimal } from 'vuelidate/lib/validators'
export default {
  name: 'product.pricing',
  props: {
    product_id: { type: String, required: true }
  },
  data: () => ({
    isLoading: false,
    product: {},
    price_history: []
  }),
  mounted () {
    this.onInit()
  },
  watch: {
    product_id: { handler: 'onInit', immediate: true }
  },
  validations: {
    product: {
      sales_price: {
        required,
        minValue: minValue(0),
        decimal
      },
      cost_price: {
        required,
        minValue: minValue(0),
        decimal
      }
    }
  },
  methods: {
    async onInit () {
      this.isLoading = true
      let item = await api.items.fetch({
        id: this.product_id
      })
      let { items } = await api.itemsalesPriceAudits.fetchPage(
        this.product_id,
        {
          page: 1,
          pageSize: -1,
          orderBy: { created_at: 'desc' }
        }
      )

      this.price_history = [...items]
      this.product = {
        ...item
      }
      this.isLoading = false
    },
    async onSave () {
      let valid = true

      if (valid) {
        const data = {
          ...this.product
        }

        try {
          this.isLoading = true
          let item = await api.items.update({
            ...data,
            id: this.product_id
          })
          this.$bvToast.toast(`Product info was saved!`, {
            title: 'Changes Saved',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.$emit('update')
          this.onInit()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false

          this.$bvToast.toast(`${error}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
        }
      }
    }
  }
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title border-bottom pb-3 mb-4">Pricing</h4>

      <b-form-group
        label="VAT %"
        label-for="product_vat_rate"
        label-cols-sm="3"
        label-cols-lg="2"
      >
        <app-vat-select
          v-model="product.vat_rate"
          id="product_vat_rate"
          :style="{ maxWidth: '150px' }"
        />
      </b-form-group>

      <b-form-group
        label="Sales Price *"
        label-for="sales_price"
        label-cols-lg="2"
        label-cols-sm="3"
      >
        <b-input-group>
          <b-form-input
            id="sales_price"
            v-model.number="$v.product.sales_price.$model"
            required
            :style="{ maxWidth: '100px' }"
            class="text-center"
          ></b-form-input>
          <b-input-group-append is-text> EUR </b-input-group-append>
          <b-input-group-append is-text v-if="price_history.length > 0">
            <b-btn
              variant="link"
              class="p-0"
              size="sm"
              v-b-modal.price-history-modal
            >
              <i class="fas fa-history pointer"></i>
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group
        label="Cost Price *"
        label-for="cost_price"
        label-cols-lg="2"
        label-cols-sm="3"
      >
        <b-input-group>
          <b-form-input
            id="cost_price"
            v-model.number="$v.product.cost_price.$model"
            required
            :style="{ maxWidth: '100px' }"
            class="text-center"
          ></b-form-input>
          <b-input-group-append is-text> EUR </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <div class="d-flex justify-content-end border-top pt-3">
        <b-btn class="btn-label" variant="primary" v-on:click="onSave">
          <i class="bx bx-save label-icon"></i>Save Changes
        </b-btn>
      </div>
    </b-card>

    <b-modal
      id="price-history-modal"
      title="Sales Price History"
      body-class="modal-height-sm"
      size="sm"
      ok-only
      v-if="price_history.length > 0"
    >
      <template v-for="p in price_history">
        <div :key="p.id" class="d-flex flex-column py-2">
          <div class="d-flex justify-content-between mb-0">
            <span>New Price: </span
            ><span>{{ p.sales_price_after }}<small>EUR</small></span>
          </div>
          <div class="d-flex justify-content-between mb-0">
            <span>Old Price:</span>
            <span>
              {{ p.sales_price_before }}
              <small>EUR</small>
            </span>
          </div>
          <div class="d-flex justify-content-between mt-1">
            <small>{{ p.created_at | moment('DD/MM/YYYY HH:mm') }}</small>
            <small v-if="p.user">by {{ p.user.name }}</small>
          </div>
        </div>
      </template>
    </b-modal>
  </g-overlay>
</template>
